import { keyframes, css } from '@creditas/stylitas'

import { rtNamespace } from '../variables'

const zoomIn = keyframes`
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
`

const zoomOut = keyframes`
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
`

const zoom = css`
  .${rtNamespace}__zoom-enter {
    animation-name: ${zoomIn};
  }

  .${rtNamespace}__zoom-exit {
    animation-name: ${zoomOut};
  }
`

export { zoom }
